import { applicationFormUrl } from './contact'

// Pega aquí la URL de tu video BCL (YouTube, Vimeo o un archivo .mp4).
export const bclVideoUrl = ''

// Pega aquí el enlace externo al que debe llevar el botón principal.
export const nextStepUrl = applicationFormUrl

export const bclCoverImage = 'https://cdn.magicpatterns.com/patterns/generated-images/cb64f1a5-1806-4be0-9730-273023f5ba81.jpg'
